import React from 'react';

// Compact three-cell bar under the title: client name, location, industry.
// Not a CanvasSection — a single hairline-bordered strip like a mini table.

const Cell: React.FC<{ label: string; value: string; onChange: (v: string) => void; placeholder?: string }> = ({ label, value, onChange, placeholder }) => (
  <label className="block px-4 py-3">
    <span className="block text-[10.5px] font-semibold uppercase tracking-[0.08em] text-[color:var(--oa-muted)]">{label}</span>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="mt-1 w-full bg-transparent text-[13.5px] font-medium text-[color:var(--oa-text)] outline-none placeholder:font-normal placeholder:text-[color:var(--oa-faint)]"
    />
  </label>
);

export const ClientStrip: React.FC<{
  clientName: string;
  onClientName: (v: string) => void;
  clientLocation: string;
  onClientLocation: (v: string) => void;
  industry: string;
  onIndustry: (v: string) => void;
}> = ({ clientName, onClientName, clientLocation, onClientLocation, industry, onIndustry }) => (
  <div className="mb-8 grid grid-cols-1 divide-y divide-[color:var(--oa-line-2)] rounded-xl border border-[color:var(--oa-line-2)] bg-[color:var(--oa-card)] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
    <Cell label="Client name" value={clientName} onChange={onClientName} placeholder="Company name" />
    <Cell label="Location" value={clientLocation} onChange={onClientLocation} placeholder="City, Country" />
    <Cell label="Industry" value={industry} onChange={onIndustry} placeholder="e.g. Hospitality" />
  </div>
);
